import { initialiseCarousel } from './_helpers'
import { mediaBreakpoints } from '../utils'
import {getElement, getElements} from './../utils/functional'
import 'swiper/swiper.scss';

export default function init ({ el, context }) {
  const moduleClassName = el.dataset.moduleClassName
  const swiperContainer = el.getElementsByClassName(`${moduleClassName}_Carousel`)[0]
  const swiperPaginationClass = `${moduleClassName}_Pagination`
  const swiperPaginationElement = el.querySelector(`.${moduleClassName}_Pagination`)
  
  const slideClass = `${moduleClassName}_Slide`
  
  makeCarousel();

  function makeCarousel () {
    var swiperInstance = initialiseCarousel(swiperContainer, {
      loop: false,
      autoplay: true,
      delay: 3300,
      stopOnLastSlide: true,
      spaceBetween: 20,
      slideClass: slideClass,
      slidesPerView: 1,
      preloadImages: true,
      breakpointsInverse: true,
      disableOnInteraction: true,
      watchSlidesProgress: true,
      breakpoints: {
        769: {
          loop: false,
          allowTouchMove: false,
          slidesPerView: 3,
          spaceBetween: 30,
          autoplay: {
            delay: 6000000,
            disableOnInteraction: false,
            stopOnLastSlide: true,
          },
        },
      },
      pagination: {
        el: swiperPaginationElement,
        type: "bullets",
        clickable: true,
      },
    });
  }
}